import React, { useContext } from 'react';

import { useTranslation } from 'next-i18next';
// import PropTypes from 'prop-types';
import s from './HeroNews.module.scss';
import { useInView } from 'react-intersection-observer';
import classNames from 'classnames';
import Image from 'next/image';
import { GradientContext } from '../../containers/BasePage';
import getFocalImageStyles from '../../utils/getFocalImageStyles';
import ButtonSecondary from '../ButtonSecondary';
import GradientBlurb from '../GradientBlurb';
import PhotoCred from '../PhotoCred/PhotoCred';
const HeroNews = ({
  category,
  titleTop,
  titleBottom,
  text,
  lastUpdated,
  image,
  link,
  modifiers = [],
  share = {
    onClick: () => {},
  },
}) => {
  const imageStyle = { objectFit: 'contain' };
  const { t } = useTranslation();
  const gradient = useContext(GradientContext);
  const { ref, inView } = useInView({
    threshold: 0.1,
    triggerOnce: true,
  });

  const classes = classNames(
    s.Root,
    {
      [s.Visible]: inView,
    },
    s[gradient],
    modifiers.map((m) => s[m])
  );

  return (
    <div className={classes} ref={ref}>
      <GradientBlurb modifiers={['HeroNews']} />
      <GradientBlurb modifiers={['HeroNews--Bottom']} />
      <div className={s.Container}>
        <div className={s.TextContainer}>
          {category && <div className={s.Tagline}>{category.title}</div>}
          <h1 className={s.TitleContainer}>
            <span className={s.TitleTop}>{titleTop}</span>
            <span className={s.TitleBottom}>{titleBottom}</span>
          </h1>
          {lastUpdated && (
            <div className={s.PublishedDate}>
              {t('Common.publishedDate', { date: lastUpdated })}
            </div>
          )}
          {text && <p className={s.Text}>{text}</p>}
          <div className={s.ButtonWrapper}>
            <ButtonSecondary
              animateIcon
              modifiers={['InlineFlex', 'IconRotate45', 'Share', 'LargeOnly']}
              icon="icon-share-white"
              onClick={share.onClick}>
              {t('Generic.share')}
            </ButtonSecondary>
          </div>
        </div>
        {image && image.url && (
          <div className={s.ImageContainer}>
            <div className={s.ImageWrapper}>
              <div className={s.ImageInner}>
                <Image
                  className={s.Image}
                  src={image?.url}
                  alt={image?.alt || ''}
                  fill
                  style={getFocalImageStyles(image)}
                />
                <div className={s.ImageGradient}></div>
              </div>
              <PhotoCred credit={image?.credit} modifiers={['']} />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

HeroNews.propTypes = {};

export default HeroNews;
